export default defineNuxtPlugin({
  name: 'i18n-switch-locale',
  dependsOn: ['analytics'],
  setup({ hook, $rollbar, $analytics }) {
    // onLanguageSwitched called right after a new locale has been set
    hook('i18n:localeSwitched', ({ oldLocale, newLocale }) => {
      try {
        $analytics.track('switchLocale', {
          oldLocale,
          newLocale,
        });
      } catch (error) {
        $rollbar.error('Analytics', error);
      }
    });
  },
});
